import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';

export const useLogClickEditFolderOrder = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(() => {
    logAnalyticsEvent({ name: 'CLICK_EDIT_FOLDER_ORDER' });
  }, [logAnalyticsEvent]);
};
